/*
 * Offre Rentrée 2026 « Back to Road » : la Live Alarm offerte pour tout GeoRide 3s.
 *
 * PIVOT DU 19/08 (Antoine) : retour ISO Back to Road 2025. Il n'y a plus qu'UN seul
 * accessoire offert, donc plus aucun choix à faire : ni pop-up, ni rangée d'échange,
 * ni carte de sélection sur la fiche produit. La Live Alarm est ajoutée
 * SILENCIEUSEMENT au panier dès qu'un GeoRide 3s y entre, la remise BXGY serveur la
 * passe à 0 €. Le client voit son panier avec la ligne « Offert », point.
 *
 * Principe (cf. Marketing/offre-rentree-2026/benchmark-selecteur-cadeau.md) :
 *  - Shopify n'ajoute JAMAIS le produit offert d'une remise BXGY. Ce script l'ajoute,
 *    la remise BXGY serveur le passe à 0 €.
 *  - Tout passe par le flux mm officiel : mmAPIRequest + refreshCartFromData.
 *    Aucun fetch parallèle, aucun rendu de panier maison.
 *  - La vérité vient du serveur : la section mm-cart est re-rendue à chaque mutation
 *    et expose l'état réel du panier (déclencheur présent, ligne cadeau, allocation
 *    de remise, variant de l'accessoire offert) dans les data-attributs de
 *    [data-gr-gift].
 *  - La QUANTITÉ offerte suit le nombre de GeoRide 3s au panier (2 GeoRide 3s =
 *    2 Live Alarm offertes), plafonnée à ce que la remise couvre réellement :
 *    si l'allocation est partielle, on redescend d'une unité (K_QCAP retient le
 *    plafond de la session). Les remises BXGY splittent les lignes côté Shopify,
 *    tout l'état est donc agrégé par groupe de lignes (data-line-keys).
 *  - Si la ligne cadeau perd son allocation -100 %, elle est retirée avec un message :
 *    jamais de cadeau qui redevient payant en silence.
 *  - Sans JavaScript, rien ne casse : la remise BXGY serveur couvre l'ajout manuel de
 *    la Live Alarm par le client.
 */
(function () {
    "use strict";

    var PROP = "_gr_gift_rentree26";

    var K_LAST = "gr_gift_r26_last"; // dernier variant de cadeau vu au panier
    var K_OFF = "gr_gift_r26_off"; // le client a retiré son cadeau : on ne le remet pas
    var K_MUTE = "gr_gift_r26_mute"; // l'offre ne s'applique plus : on n'ajoute plus
    var K_MSG = "gr_gift_r26_msg"; // message à afficher dans le drawer
    var K_QCAP = "gr_gift_r26_qcap"; // plafond de quantité réellement couvert par la remise

    var MSG = {
        no_trigger: "Live Alarm a été retiré du panier : il faut un GeoRide 3s dans le panier.",
        no_allocation: "Live Alarm a été retiré du panier : l'offre ne s'applique plus à ton panier.",
        other_free: "Live Alarm a été retiré du panier : la remise s'applique déjà sur un autre accessoire de ton panier.",
        offer_over: "L'offre de rentrée est terminée : Live Alarm n'est plus offert.",
    };

    var MAX_FAILURES = 3; // au-delà, on lâche l'affaire pour la session (429, réseau, etc.)
    var SYNC_DELAY = 400; // laisse finir le flux « frais de mise en service » de mm-cart.js

    var busy = false;
    var failures = 0;
    var strikes = 0; // etats « pas 100 % offerte » consecutifs : on ne retire qu'au 2e
    var syncTimer = null;
    var pendingMsg = "";
    var memStore = {};

    /* ---------- petit stockage de session, tolérant (Safari privé) ---------- */

    function ssGet(key) {
        try {
            var v = window.sessionStorage.getItem(key);
            return v === null ? (memStore[key] || "") : v;
        } catch (e) {
            return memStore[key] || "";
        }
    }

    function ssSet(key, value) {
        memStore[key] = value;
        try {
            window.sessionStorage.setItem(key, value);
        } catch (e) {
            /* stockage indisponible : on reste en mémoire */
        }
    }

    function ssDel(key) {
        delete memStore[key];
        try {
            window.sessionStorage.removeItem(key);
        } catch (e) {
            /* idem */
        }
    }

    /* ---------- lecture de l'état serveur ---------- */

    function root() {
        return document.querySelector("[data-gr-gift]");
    }

    function attr(el, name) {
        return el.getAttribute(name) || "";
    }

    function isTrue(value) {
        return String(value) === "true";
    }

    function readState() {
        var el = root();
        if (!el) return null;

        // Lignes du groupe cadeau au format "key:qty,key:qty," : les remises BXGY
        // splittent la ligne côté Shopify, l'état est donc toujours un agrégat.
        var lineKeys = parseLineKeys(attr(el, "data-line-keys"));

        return {
            el: el,
            active: isTrue(attr(el, "data-gift-active")),
            hasTrigger: isTrue(attr(el, "data-has-trigger")),
            triggerQty: parseInt(attr(el, "data-trigger-qty"), 10) || 0,
            lineKey: attr(el, "data-line-key"),
            lineKeys: lineKeys,
            lineQty: parseInt(attr(el, "data-line-qty"), 10) || 0,
            lineVariant: attr(el, "data-line-variant"),
            discounted: isTrue(attr(el, "data-line-discounted")),
            partial: isTrue(attr(el, "data-line-partial")),
            otherFree: isTrue(attr(el, "data-other-free")),
            // Live Alarm ajoutées PAR LE CLIENT (sans la propriété du script) : elles
            // comptent comme cadeau présent, jamais comme « autre accessoire ».
            manualQty: parseInt(attr(el, "data-gift-manual-qty"), 10) || 0,
            // Variant de l'accessoire offert, rendu par mm-cart.liquid depuis le
            // réglage « handles des accessoires offerts » (le premier de la liste).
            giftVariant: attr(el, "data-gift-variant"),
            giftAvailable: attr(el, "data-gift-available") !== "false",
        };
    }

    function mmReady() {
        return (
            typeof window.mmAPIRequest === "function" &&
            typeof window.refreshCartFromData === "function" &&
            document.querySelector(".mm-dc-products")
        );
    }

    /* ---------- messages ---------- */

    // Une Live Alarm (ajoutée par le script ou par le client) est-elle au panier ?
    // Lu dans le DOM rendu par le serveur : c'est la seule vérité.
    function giftInCart() {
        var el = root();
        if (!el) return false;
        var qty = (parseInt(attr(el, "data-line-qty"), 10) || 0) + (parseInt(attr(el, "data-gift-manual-qty"), 10) || 0);
        return qty > 0;
    }

    function renderNotice() {
        var el = document.querySelector("[data-gr-gift-notice]");
        if (!el) return;

        // Tous les messages disent « Live Alarm a été retiré » : ils n'ont de sens
        // que si aucune Live Alarm n'est au panier (fix 31/08 : message fantôme).
        if (pendingMsg && !giftInCart()) {
            el.textContent = pendingMsg;
            el.hidden = false;
        } else {
            el.textContent = "";
            el.hidden = true;
        }
    }

    function setMessage(reason) {
        pendingMsg = MSG[reason] || MSG.no_allocation;
        ssSet(K_MSG, pendingMsg);
        renderNotice();
    }

    function clearMessage() {
        pendingMsg = "";
        ssDel(K_MSG);
        renderNotice();
    }

    /* ---------- mutations panier (flux mm officiel) ---------- */

    function addPayload(variantId, quantity) {
        var item = { id: Number(variantId), quantity: quantity || 1, properties: {} };
        item.properties[PROP] = "1";
        return { items: [item], sections: "mm-cart" };
    }

    function release() {
        busy = false;
        if (typeof window.mmDisableCheckout === "function") {
            try {
                window.mmDisableCheckout(false);
            } catch (e) {
                /* le CTA n'est pas rendu sur cette page */
            }
        }
        scheduleSync();
    }

    function onError(label) {
        return function (error) {
            failures += 1;
            console.warn("[gr-gift] " + label, error);
        };
    }

    function hold() {
        busy = true;
        if (typeof window.mmDisableCheckout === "function") {
            try {
                window.mmDisableCheckout(true);
            } catch (e) {
                /* idem */
            }
        }
    }

    function addGift(variantId, quantity) {
        if (!mmReady()) return;

        hold();
        clearMessage();

        window
            .mmAPIRequest("POST", "cart/add.js", addPayload(variantId, quantity))
            .then(function (data) {
                failures = 0;
                return window.refreshCartFromData(data);
            })
            .catch(onError("ajout impossible"))
            .then(release);
    }

    // Trace de decisions (rolling 30, sessionStorage) : diagnostic QA/SAV sans console.
    function dbg(entry) {
        try {
            var arr = JSON.parse(ssGet("gr_gift_r26_dbg") || "[]");
            arr.push(Date.now() % 1000000 + " " + entry);
            if (arr.length > 30) arr = arr.slice(-30);
            ssSet("gr_gift_r26_dbg", JSON.stringify(arr));
        } catch (e) {
            /* diagnostic uniquement */
        }
    }

    function parseLineKeys(raw) {
        return (raw || "")
            .split(",")
            .filter(function (part) {
                return part;
            })
            .map(function (part) {
                var bits = part.split("|");
                return { key: bits[0], qty: parseInt(bits[1], 10) || 0, fin: parseInt(bits[2], 10) || 0 };
            });
    }

    // Rapproche le TOTAL du groupe cadeau de `newTotal`, UNE ligne par cycle de
    // sync : les lignes splittées par une remise BXGY ont des clés DISTINCTES, on
    // vise donc une ligne précise. Pour baisser, on retire d'abord les lignes NON
    // offertes (final > 0) — jamais la ligne gratuite tant qu'une payante existe.
    // Le reste du delta est traité au cycle suivant (clés fraîches du re-rendu).
    function setGiftQty(state, newTotal, reason, mute) {
        if (!mmReady() || !state.lineKeys.length) return;

        var delta = newTotal - state.lineQty;
        var line = null;
        var lineQty = 0;
        if (delta > 0) {
            line = state.lineKeys[0];
            lineQty = line.qty + delta;
        } else if (delta < 0) {
            var pool = state.lineKeys.filter(function (l) {
                return l.fin > 0 && l.qty > 0;
            });
            if (!pool.length) {
                pool = state.lineKeys.filter(function (l) {
                    return l.qty > 0;
                });
            }
            if (!pool.length) return;
            line = pool[pool.length - 1];
            lineQty = Math.max(0, line.qty + delta);
        } else {
            return;
        }
        dbg("setGiftQty total " + state.lineQty + "->" + newTotal + " via " + line.key.slice(0, 8) + "… q" + line.qty + "->" + lineQty);

        hold();
        if (newTotal <= 0) {
            // retrait complet : mêmes effets de bord que l'ancien removeGift
            ssDel(K_LAST);
            if (mute) ssSet(K_MUTE, "1");
        }
        if (reason) setMessage(reason);

        window
            .mmAPIRequest("POST", "cart/change.js", {
                id: line.key,
                quantity: lineQty,
                sections: "mm-cart",
            })
            .then(function (data) {
                failures = 0;
                return window.refreshCartFromData(data);
            })
            .catch(onError("ajustement impossible"))
            .then(release);
    }

    function removeGift(state, reason, mute) {
        setGiftQty(state, 0, reason, mute);
    }

    /* ---------- boucle de synchronisation ---------- */

    function scheduleSync(delay) {
        if (syncTimer) clearTimeout(syncTimer);
        syncTimer = setTimeout(
            function () {
                syncTimer = null;
                sync();
            },
            typeof delay === "number" ? delay : SYNC_DELAY
        );
    }

    function sync() {
        var state = readState();
        if (!state) return;

        renderNotice();
        if (busy) return;
        // Un message « retiré du panier » périmé (persisté en session) s'efface dès
        // qu'une Live Alarm est de nouveau au panier, quelle que soit son origine.
        if (pendingMsg && (state.lineQty > 0 || state.manualQty > 0)) clearMessage();
        if (failures >= MAX_FAILURES) return;
        dbg(
            "state trig=" + state.triggerQty + " lineQ=" + state.lineQty + " manual=" + state.manualQty +
            " keys=" + state.lineKeys.map(function (l) { return l.key.slice(0, 8) + ":" + l.qty; }).join(",") +
            " disc=" + state.discounted + " part=" + state.partial +
            " other=" + state.otherFree + " strikes=" + strikes
        );

        // Quantité cible : une Live Alarm par GeoRide 3s, plafonnée à ce que la
        // remise couvre réellement (K_QCAP, appris quand une allocation est partielle).
        var qcap = parseInt(ssGet(K_QCAP), 10) || 0;
        var target = state.triggerQty > 0 ? state.triggerQty : 1;
        if (qcap > 0 && target > qcap) target = qcap;

        // 1. Une ligne cadeau est au panier : elle doit rester légitime et gratuite.
        if (state.lineKey) {
            if (!state.active) {
                removeGift(state, "offer_over", true);
                return;
            }
            if (!state.hasTrigger) {
                removeGift(state, "no_trigger", false);
                return;
            }
            if (state.discounted) {
                strikes = 0;
                // 100 % offerte : la quantité suit le nombre de GeoRide 3s.
                if (state.lineQty < target && state.giftVariant && state.giftAvailable) {
                    dbg("action raise-to " + target);
                    setGiftQty(state, target);
                    return;
                }
                if (state.lineQty > target) {
                    dbg("action lower-to " + target);
                    setGiftQty(state, target);
                    return;
                }
                ssSet(K_LAST, state.lineVariant);
                clearMessage();
                return;
            }
            // Pas 100 % offerte. Après une mutation, Shopify peut rendre la section
            // AVANT d'avoir recalculé les allocations de remise : on exige de voir
            // l'état fautif sur DEUX syncs consécutifs avant d'agir, sinon un
            // transitoire retirerait le cadeau à tort (observé en QA : shrink 2→1
            // puis rendu sans allocation → retrait complet muet).
            strikes += 1;
            if (strikes < 2) {
                scheduleSync(900);
                return;
            }
            strikes = 0;
            if (state.partial && state.lineQty > 1) {
                // La remise ne couvre qu'une partie du groupe : on redescend d'une
                // unité et on retient le plafond — jamais de cadeau payant.
                dbg("action partial-lower-to " + (state.lineQty - 1) + ", qcap=" + (state.lineQty - 1));
                ssSet(K_QCAP, String(state.lineQty - 1));
                setGiftQty(state, state.lineQty - 1);
                return;
            }
            dbg("action REMOVE " + (state.otherFree ? "other_free" : "no_allocation"));
            removeGift(state, state.otherFree ? "other_free" : "no_allocation", true);
            return;
        }

        // 2. Pas de ligne cadeau.
        strikes = 0;
        if (!state.active || !state.hasTrigger) {
            ssDel(K_LAST);
            return;
        }
        // Le client a déjà mis une Live Alarm au panier lui-même : la remise BXGY
        // serveur la passe à 0 €, rien à ajouter (sinon doublon → l'un des deux reste
        // payant → retrait + message alors que la Live Alarm est bien là). On note
        // le variant pour qu'un retrait ultérieur soit lu comme volontaire (K_OFF).
        if (state.manualQty > 0) {
            ssSet(K_LAST, state.giftVariant || "manual");
            return;
        }
        if (ssGet(K_OFF) === "1" || ssGet(K_MUTE) === "1") return;

        // Un cadeau était là, le déclencheur est toujours au panier, et la ligne a
        // disparu sans que ce script l'ait retirée : c'est un retrait volontaire.
        // On ne le remet pas de la session (pas de bras de fer avec le client).
        if (ssGet(K_LAST)) {
            ssSet(K_OFF, "1");
            ssDel(K_LAST);
            return;
        }

        // 3. Ajout silencieux de la Live Alarm (une par GeoRide 3s).
        if (state.giftVariant && state.giftAvailable) { dbg("action initial-add x" + target); addGift(state.giftVariant, target); }
    }

    /* ---------- branchements ---------- */

    // Appelé par mm-cart.js après chaque re-rendu du panier. Volontairement différé :
    // mm-cart.js enchaîne ses propres mutations (frais de mise en service) juste avant,
    // on attend que le panier se stabilise pour ne pas lancer deux écritures en parallèle.
    window.grGiftOnCartUpdate = function () {
        // Diagnostic : rangées affichées après ce re-rendu (id de variante : qté),
        // dans l'ordre du DOM. Lisible via sessionStorage gr_gift_r26_dbg.
        try {
            var rows = Array.prototype.map.call(
                document.querySelectorAll(".mm-dc-products [data-cart-item-id]"),
                function (r) { return String(r.dataset.cartItemId).slice(-4) + ":" + (r.dataset.itemQuantity || "-"); }
            );
            dbg("rows " + rows.join(" "));
        } catch (e) {
            /* diagnostic uniquement */
        }
        renderNotice();
        scheduleSync();
    };

    document.addEventListener(
        "DOMContentLoaded",
        function () {
            pendingMsg = ssGet(K_MSG) || "";
            scheduleSync(0);
        },
        { once: true }
    );
})();
